import Filter from "components/filters";
import { useBudgetFamilyContext } from "../../context";
import { familyFilterDefault, familySelectFilters } from "../../utils";
import { useEffect, useState } from "react";
import { SelectBox } from "components/uikit-adapter";

export interface FamilyFilterProps {
  showFilter: boolean;
  triggerClose: () => void;
  handleSearch: (filter: any) => void;
  handleClear: () => void;
  filtersDefault: any;
  disabledSearch?: boolean;
}

const FamilyFilter = ({
  showFilter,
  triggerClose,
  handleSearch,
  handleClear,
  filtersDefault,
  disabledSearch,
}: FamilyFilterProps) => {
  const {
    materialGroups,
    fetchFamiliesForFilter,
    familiesForFilter,
    setFamiliesForFilter,
  } = useBudgetFamilyContext();
  const [selectsFilters, setSelectsFilters] = useState(familySelectFilters());
  const [filters, setFilters] = useState(filtersDefault);

  const updateFilterOptions = () => {
    setSelectsFilters(prev => prev.map(item => ({ 
      ...item, 
      options: item.name == "MaterialGroupId" ? materialGroups : familiesForFilter
    })));
  };

  const handleChange = (value: any, field: string) => {
    setFilters((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleSearchFilter = () => {
    handleSearch(filters);
  }

  const handleClearFilter = () => {
    setFilters(familyFilterDefault);
    handleClear();
  };

  useEffect(() => {
    updateFilterOptions();
  }, [materialGroups, familiesForFilter]);

  useEffect(() => {
    if(!filters.MaterialGroupId?.Id) {
      setFamiliesForFilter([]);
    } else {
      fetchFamiliesForFilter(filters.MaterialGroupId?.Id);
    }
  }, [filters.MaterialGroupId]);

  useEffect(() => {
    const actualFilterIsIncluded = familiesForFilter.some((item: any) => item.Id == filters.FamilyId);
    if(!actualFilterIsIncluded) {
      setFilters((prevState: any) => ({
        ...prevState,
        FamilyId: null,
      }));
    }
  }, [familiesForFilter])

  return (
    <Filter
      showFilter={showFilter}
      triggerClose={triggerClose}
      handleCloseSearch={handleSearchFilter}
      handleCleanClick={handleClearFilter}
      disabledSearch={disabledSearch}
    >
      {selectsFilters.map(
        (selectFilter) =>
          //@ts-ignore
          <SelectBox
            key={selectFilter.name}
            {...selectFilter}
            value={filters[selectFilter.name]}
            onChange={(value: any) => handleChange(value, selectFilter.name)}
            data-testid={`selectbox-${selectFilter.name}`}
          />
      )}
    </Filter>
  );
};

export default FamilyFilter;
